import { render, staticRenderFns } from "./TaxProfileSummary.vue?vue&type=template&id=56b86b18&scoped=true&"
import script from "./TaxProfileSummary.vue?vue&type=script&lang=js&"
export * from "./TaxProfileSummary.vue?vue&type=script&lang=js&"
import style0 from "./TaxProfileSummary.vue?vue&type=style&index=0&id=56b86b18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b86b18",
  null
  
)

export default component.exports